/**
 * The CSRF header the api's `isCsrfSafe` looks for on a state-changing browser request
 * (`apps/api/src/modules/auth/cookies.ts`, M0-F3 §5.3).
 *
 * The tRPC client already sends it; the playground's proxy call is a plain `fetch`, so it has
 * to send it too. Written out here rather than imported, because `apps/web` does not depend on
 * `apps/api` at runtime.
 */
export const CLIENT_HEADER_NAME = 'x-elizmonday-client';
